import { AxiosError } from 'axios';
import { GET_ANNOUNCEMENT_CONFIG_QUERY_KEY } from 'web-library/constants/queryKeys';
import { GET_ANNOUNCEMENT_CONFIG_URL } from 'web-library/constants/apiUrls';
import { AnnouncementConfig } from 'web-library/models/Announcements';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  announcementType: string;
  onSuccess?: (data: AnnouncementConfig) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAnnouncementConfig = ({ announcementType, onSuccess, onError }: Input) => {
  const getAnnouncementConfig = async () => {
    const res = await axiosClient.get<AnnouncementConfig>(
      GET_ANNOUNCEMENT_CONFIG_URL(announcementType)
    );
    return res.data;
  };
  return useCustomQuery(
    GET_ANNOUNCEMENT_CONFIG_QUERY_KEY.concat(announcementType),
    getAnnouncementConfig,
    {
      onSuccess,
      onError,
    }
  );
};
